// extracted by mini-css-extract-plugin
module.exports = {"SummaryBarChart":"SummaryBarChart","scoresText":"scoresText","targetText":"targetText","targetValue":"targetValue"};